<template>
  <button
    :class="btnClass"
    :style="btnStyle"
    :disabled="loading"
    @click="exportToExcel"
  >
    <slot>{{ name || 'Download Excel' }}</slot>
  </button>
</template>

<script>
import ExcelJS from 'exceljs'

export default {
  name: 'JsonExcel',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    fields: {
      type: Object,
      default: () => ({})
    },
    name: {
      type: String,
      default: 'data.xlsx'
    },
    type: {
      type: String,
      default: 'xlsx'
    },
    btnClass: {
      type: String,
      default: 'btn btn-primary'
    },
    btnStyle: {
      type: Object,
      default: () => ({})
    },
    worksheet: {
      type: String,
      default: 'Sheet1'
    }
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {
    exportToExcel() {
      this.loading = true
      
      try {
        // Process data based on fields mapping
        let exportData = this.data
        
        if (this.fields && Object.keys(this.fields).length > 0) {
          exportData = this.data.map(item => {
            const newItem = {}
            Object.keys(this.fields).forEach(key => {
              const fieldConfig = this.fields[key]
              if (typeof fieldConfig === 'string') {
                newItem[fieldConfig] = item[key]
              } else if (typeof fieldConfig === 'object') {
                const label = fieldConfig.label || key
                newItem[label] = item[key]
              }
            })
            return newItem
          })
        }
        
        // Create workbook and worksheet
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet(this.worksheet);
        
        // Add headers
        if (exportData.length > 0) {
          const headers = Object.keys(exportData[0]);
          worksheet.addRow(headers);
          
          // Add data rows
          exportData.forEach(item => {
            worksheet.addRow(Object.values(item));
          });
        }
        
        // Generate file name with extension
        let fileName = this.name;
        if (!fileName.includes('.')) {
          fileName += `.${this.type}`;
        }
        
        // Write file
        workbook.xlsx.writeBuffer().then(buffer => {
          const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.style = 'display: none';
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
          
          this.$emit('export-started');
          this.$emit('export-finished');
        });
        
      } catch (error) {
        console.error('Export error:', error);
        this.$emit('export-error', error);
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>
